import { Divider, Grid } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FeeStartDate } from './FeeStartDate';
import { PerCheckAmount } from './PerCheckAmount';
import { PerCheckAmountFee } from './PerCheckAmountFee';
import { StartDate } from './StartDate';
import { TotalAmount } from './TotalAmount';
import { TotalAmountFee } from './TotalAmountFee';

const useStyles = makeStyles()(theme => ({
  dateContainer: {
    '& .MuiInputBase-root.Mui-disabled': {
      background: '#f5f5f5',
    },
    minWidth: '350px',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    padding: '10px',
    minWidth: '350px',
  },
  root: {
    flexGrow: 1,
  },
}));

export const OgpIntLoan = () => {
  const { classes } = useStyles();
  return (
    <>
      <div className={classes.root}>
        <Grid container direction="column" spacing={4} className={classes.gridContainer}>
          <Grid xs={12} item className={classes.dateContainer}>
            <TotalAmount />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <PerCheckAmount />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <StartDate />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <Divider />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <TotalAmountFee />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <PerCheckAmountFee />
          </Grid>
          <Grid xs={12} item className={classes.dateContainer}>
            <FeeStartDate />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
